import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Trans } from '@lingui/react';

import Toast from './toast';
import toastActions from '../../containers/console/actions/toast-actions';
import successIcon from '../../assets/images/icons/ico_success.svg';

function ToastHost({ items, hideToast }) {
    useEffect(() => {
        const timers = items.map((t) => {
            if (!t.autoCloseMs) return null;
            return window.setTimeout(() => hideToast(t.id), t.autoCloseMs);
        });

        return () => timers.forEach(timer => timer && window.clearTimeout(timer));
    }, [items]);

    if (!items.length) return null;

    const toast = items[items.length - 1];

    console.log('toast variant', toast.variant);

    return (
        <Toast
            variant={toast.variant}
            icon={toast.variant === 'success' ? successIcon : null}
            showToast
            hideIcon={toast.variant === 'success'}
            message={<Trans id={toast.messageId} values={toast.values} />}
            onClose={() => hideToast(toast.id)}
            showCloseButton
        />
    );
}

ToastHost.propTypes = {
    items: PropTypes.array,
    hideToast: PropTypes.func
};

function mapStateToProps(state) {
    return {
        items: state.toast.items
    };
}

export default connect(mapStateToProps, toastActions)(ToastHost);



// WEBPACK FOOTER //
// ./components/toast/toast-host.js